/* ============================================================
   lamin. — global.js
   Cart AJAX, mobile drawer, toast, favorites, variant selection
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Header scroll transparency ---------- */
  (function(){
    var header = document.querySelector('.lamin-header');
    if(!header) return;
    function onScroll(){
      if(window.scrollY > 20){
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    onScroll();
  })();

  /* ---------- Toast ---------- */
  var toastEl = document.getElementById('lamin-toast');
  var toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('show');
    }, 1800);
  }
  window.laminToast = toast;

  /* ---------- Money formatting ---------- */
  function formatMoney(cents) {
    var fmt = (window.laminMoneyFormat || '${{amount}}');
    var amount = (cents / 100).toFixed(2);
    // basic thousands separators
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    amount = parts.join('.');
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, amount);
  }
  window.laminFormatMoney = formatMoney;

  /* ---------- Cart count update ---------- */
  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = 'cart (' + count + ')';
    });
  }
  function refreshCartCount() {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); })
      .catch(function () {});
  }
  window.laminRefreshCartCount = refreshCartCount;

  /* ---------- Add to cart (AJAX) ---------- */
  function addToCart(variantId, qty, btn) {
    if (!variantId) { toast('select options first'); return; }
    var root = (window.Shopify && window.Shopify.routes) ? window.Shopify.routes.root : '/';
    if (btn) { btn.disabled = true; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { return r.json().then(function (e) { throw e; }); }
        return r.json();
      })
      .then(function () {
        toast('added to cart \u2713');
        refreshCartCount();
      })
      .catch(function (err) {
        toast((err && err.description) ? err.description : 'could not add to cart');
      })
      .finally(function () {
        if (btn) { btn.disabled = false; }
      });
  }
  window.laminAddToCart = addToCart;

  /* ---------- Event delegation for add buttons ---------- */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('[data-add-to-cart]');
    if (addBtn) {
      e.preventDefault();
      var vid = addBtn.getAttribute('data-variant-id');
      // If inside a product form with selected variant, prefer that
      var form = addBtn.closest('form.product-form') || addBtn.closest('[data-product-form]');
      if (form) {
        var sel = form.querySelector('[name="id"]');
        if (sel && sel.value) vid = sel.value;
        var qtyInput = form.querySelector('[name="quantity"]');
        var q = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCart(vid, q, addBtn);
      } else {
        addToCart(vid, 1, addBtn);
      }
      return;
    }

    /* Favorite toggle */
    var fav = e.target.closest('[data-fav]');
    if (fav) {
      e.preventDefault();
      fav.classList.toggle('on');
      return;
    }
  });

  /* ---------- Mobile drawer ---------- */
  var drawer = document.querySelector('[data-drawer]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { drawer && drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    if (e.target.closest('[data-drawer-close]') || (drawer && e.target.classList.contains('lamin-drawer__overlay'))) {
      drawer && drawer.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) {
      drawer.classList.remove('is-open'); document.body.style.overflow = '';
    }
  });

  /* ---------- Newsletter / contact inline feedback ---------- */
  window.laminNewsletter = function (input) {
    if (input && input.value.indexOf('@') > -1) {
      toast("you're on the list \u2713");
      input.value = '';
      return false; // allow native if real form; here we block demo
    }
    input && input.focus();
    return false;
  };



  /* ---------- Initial cart count ---------- */
  if (document.querySelector('[data-cart-count]')) {
    refreshCartCount();
  }

  /* ─────────────────────────────────────────────
     Scroll reveal — IntersectionObserver
     Marks elements .lamin-reveal / .lamin-reveal-scale / .lamin-reveal-left
     as .is-visible when they enter the viewport.
     Also applies these classes automatically to section content.
     ───────────────────────────────────────────── */
  (function () {
    if (!('IntersectionObserver' in window)) {
      // Fallback: just show everything
      document.querySelectorAll('.lamin-reveal,.lamin-reveal-scale,.lamin-reveal-left').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    function observe(el) {
      observer.observe(el);
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target); // animate once
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    // Auto-apply reveal classes to common elements outside the hero
    function setupReveals() {
      // Section headings
      document.querySelectorAll('.lamin-section .sec-head, .cta-band h2, .cta-band p').forEach(function (el) {
        if (!el.closest('.hero')) { el.classList.add('lamin-reveal'); observe(el); }
      });

      // Product cards — scale reveal with stagger
      document.querySelectorAll('.prod-grid').forEach(function (grid) {
        grid.classList.add('lamin-stagger');
        grid.querySelectorAll('.card-product, .card').forEach(function (card) {
          card.classList.add('lamin-reveal-scale');
          observe(card);
        });
      });

      // Values grid items
      document.querySelectorAll('.val-grid').forEach(function (grid) {
        grid.classList.add('lamin-stagger');
        grid.querySelectorAll('.val').forEach(function (val) {
          val.classList.add('lamin-reveal');
          observe(val);
        });
      });

      // Brand ticker wrap
      document.querySelectorAll('.brand-ticker-wrap').forEach(function (el) {
        el.classList.add('lamin-reveal'); observe(el);
      });

      // Newsletter signup
      document.querySelectorAll('.signup').forEach(function (el) {
        el.classList.add('lamin-reveal'); observe(el);
      });

      // Footer columns
      document.querySelectorAll('.foot-col').forEach(function (el, i) {
        el.classList.add('lamin-reveal');
        el.style.transitionDelay = (i * 0.1) + 's';
        observe(el);
      });

      // foot-brand
      document.querySelectorAll('.foot-brand').forEach(function (el) {
        el.classList.add('lamin-reveal-left'); observe(el);
      });

      // Any manually tagged elements
      document.querySelectorAll('.lamin-reveal,.lamin-reveal-scale,.lamin-reveal-left').forEach(function (el) {
        if (!el.classList.contains('is-visible')) observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupReveals);
    } else {
      setupReveals();
    }
  })();

  /* ─────────────────────────────────────────────
     Cat tab fade — wrap the existing section-level
     tab switch with a brief opacity fade so panels
     don't snap. Works alongside the section's own
     hidden toggle — we just add/remove is-fading.
     ───────────────────────────────────────────── */
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cat-target]');
      if (!btn) return;
      var root = btn.closest('[data-section-id]');
      if (!root) return;

      // Fade out currently visible panel(s)
      root.querySelectorAll('[data-cat-panel]:not([hidden])').forEach(function (p) {
        p.classList.add('is-fading');
      });

      // After fade-out, remove fading class (section JS has already swapped hidden)
      setTimeout(function () {
        root.querySelectorAll('[data-cat-panel]').forEach(function (p) {
          p.classList.remove('is-fading');
        });
        // Re-animate cards that just appeared
        var target = btn.getAttribute('data-cat-target');
        var newPanel = root.querySelector('[data-cat-panel="' + target + '"]:not([hidden])');
        if (newPanel) {
          newPanel.querySelectorAll('.lamin-reveal-scale').forEach(function (card) {
            card.classList.remove('is-visible');
            setTimeout(function () { card.classList.add('is-visible'); }, 20);
          });
        }
      }, 320);
    });
  })();

  /* ─────────────────────────────────────────────
     Loader + Page transitions
     ───────────────────────────────────────────── */
  (function () {

    /* ── Loader (true first visit only — once per browser session) ── */
    var hasSeenLoader = sessionStorage.getItem('lamin-loaded');

    if (!hasSeenLoader) {
      sessionStorage.setItem('lamin-loaded', '1');

      var loader = document.createElement('div');
      loader.id = 'lamin-loader';
      loader.innerHTML =
        '<div class="lamin-loader__wordmark">lamin<span>.</span></div>' +
        '<div class="lamin-loader__bar"></div>';
      document.body.appendChild(loader);

      function hideLoader() {
        loader.classList.add('hidden');
        document.body.classList.add('lamin-page-ready');
        loader.addEventListener('transitionend', function () {
          loader.remove();
        }, { once: true });
      }

      var minTime = 1200;
      var start = Date.now();

      function maybeHide() {
        var elapsed = Date.now() - start;
        var wait = Math.max(0, minTime - elapsed);
        setTimeout(hideLoader, wait);
      }

      if (document.readyState === 'complete') {
        maybeHide();
      } else {
        window.addEventListener('load', maybeHide);
      }
    }

    /* ── Fade overlay (page-to-page) ── */
    var fade = document.createElement('div');
    fade.id = 'lamin-fade';

    // If we're arriving from a transition, start the overlay solid black
    // so the new page fades in from black rather than snapping in
    var arriving = sessionStorage.getItem('lamin-transition') === '1';
    if (arriving) {
      fade.classList.add('entering');
      sessionStorage.removeItem('lamin-transition');
    }

    document.body.appendChild(fade);

    // After arriving: wait one frame then slowly fade out from black
    if (arriving) {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          fade.classList.add('fade-out');
        });
      });
    }

    function isInternal(href) {
      if (!href || href.startsWith('#') || href.startsWith('mailto:') ||
          href.startsWith('tel:') || href.startsWith('javascript:')) return false;
      try {
        return new URL(href, window.location.href).hostname === window.location.hostname;
      } catch (e) { return false; }
    }

    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href]');
      if (!link) return;
      if (link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var href = link.getAttribute('href');
      if (!isInternal(href)) return;
      if (link.href === window.location.href) return;

      e.preventDefault();

      // Mark that the next page should start black and fade in
      sessionStorage.setItem('lamin-transition', '1');

      // Fade current page to black, then navigate
      fade.classList.add('leaving');
      setTimeout(function () {
        window.location.href = href;
      }, 420);
    });

  })();
})();
